/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ExecuteResultKind } from './executeResultKind';
import type { LinkedInLimitSnapshot } from './linkedInLimitSnapshot';
import type { TaskDetail } from './taskDetail';

export interface ExecuteResult {
  task: TaskDetail;
  kind: ExecuteResultKind;
  provider_action_id?: string | null;
  linkedin_limits?: LinkedInLimitSnapshot | null;
  already_connected?: boolean;
}
